/**
 * Service Emails (ADR-0036 — M10/M11).
 *
 * ConfiguracaoEmail (1 por unidade) + EmailEnviado (audit).
 */

const PREFIXO_CONFIG = "/api/configuracoes-email";
const PREFIXO_LOG = "/api/emails-enviados";


export function listarConfiguracoesEmail(request) {
  return request(PREFIXO_CONFIG);
}

export function obterConfiguracaoEmail(request, id) {
  return request(`${PREFIXO_CONFIG}/${id}`);
}

export function criarConfiguracaoEmail(request, dados) {
  return request(PREFIXO_CONFIG, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarConfiguracaoEmail(request, id, dados) {
  return request(`${PREFIXO_CONFIG}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function testarEnvioEmail(request, configId, destinatario) {
  return request(`${PREFIXO_CONFIG}/${configId}/testar`, {
    method: "POST",
    body: JSON.stringify({ destinatario }),
  });
}

export function listarEmailsEnviados(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.template_id) usp.set("template_id", params.template_id);
  if (params.destinatario) usp.set("destinatario", params.destinatario);
  if (params.situacao) usp.set("situacao", params.situacao);
  const qs = usp.toString();
  return request(`${PREFIXO_LOG}${qs ? `?${qs}` : ""}`);
}


// Helpers de UI
export const PROVIDERS_EMAIL = [
  { value: "mock", label: "Mock (dev/teste)" },
  { value: "sendgrid", label: "SendGrid" },
  { value: "mailgun", label: "Mailgun" },
  { value: "ses", label: "AWS SES" },
];

export const AMBIENTES_EMAIL = [
  { value: "HOMOLOGACAO", label: "Homologacao (forca mock automático)" },
  { value: "PRODUCAO", label: "Produção (envia email real)" },
];

export const SITUACOES_EMAIL = {
  ENVIADO: { label: "Enviado", tone: "info" },
  ENTREGUE: { label: "Entregue", tone: "success" },
  BOUNCED: { label: "Bounced", tone: "danger" },
  ERRO: { label: "Erro", tone: "danger" },
  RECUSADO: { label: "Recusado", tone: "warning" },
};
